import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useDispatch } from 'react-redux';
import { searchAssetName } from '../../features/assets/assetsSlice';
import { setNeedBounding } from '../../features/map/mapSlice';
import { setViewType } from '../../features/assets/assetsSlice';

const AssetNameSearch = () => {
    const dispatch = useDispatch();

    const onChange = (e) => {
        //console.log("Search", e.target.value);
        dispatch(setViewType("fullList"));
        dispatch(searchAssetName(`${e.target.value}`.toUpperCase()));
        dispatch(setNeedBounding(true));
    }

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            onChange(e);
        }
    }
    return (
        <Grid container spacing={1} alignItems="flex-end">
            <Grid item>
                <TextField
                    variant="standard"
                    id="standard-basic"
                    label="Search Vehicle"
                    onChange={onChange}
                    onKeyDown={handleKeyPress}

                />
            </Grid>
        </Grid>

    );
}

export default AssetNameSearch;